// extracted by mini-css-extract-plugin
export default {"skip_main_content":"CenteredLayout_skip_main_content__tNJ7Z"};